// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { getOrganisations } from './basicCreators';
import type { ThunkAction, Action } from '../../types';

export function updateCurrentOrganisation(
  organisationId: number,
  withSettings: boolean = true
): ThunkAction {
  return function(dispatch, getState) {
    const newCurrentOrg = getState().organisations.find(
      o => o.id === parseInt(organisationId, 10)
    );

    if (newCurrentOrg) {
      return Promise.all([
        dispatch(updateCurrentOrganisationSuccess(newCurrentOrg)),
        dispatch(getOrganisations(organisationId)),
        dispatch(updateCurrentOrgPermissions(organisationId))
      ])
        .then(() => Promise.resolve())
        .catch(error => Promise.reject());
    } else {
      return Promise.reject();
    }
  };
}

export function updateCurrentOrganisationSuccess(
  orgWithSettings: Object
): Action {
  return {
    type: 'UPDATE_CURRENT_ORGANISATION',
    organisation: orgWithSettings
  };
}

export function clearCurrentOrganisation() {
  return { type: 'CLEAR_CURRENT_ORGANISATION' };
}

export function updateCurrentOrgPermissions(
  organisationId: ?number = undefined
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/user/current/permissions';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };

    if (organisationId) {
      // $FlowFixMe
      options.params.organisationId = organisationId;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        const permissions = response.data.permissions;
        dispatch({
          type: 'UPDATE_CURRENT_ORGANISATION_PERMISSIONS',
          permissions
        });
      },
      error =>
        dispatch(
          APIError(
            error,
            'Error updating current org permissions for logged in user'
          )
        )
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/organisations/currentOrganisationCreators.js